import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormPanel, FormTextField } from '@eas/common-web';

export function Fields() {
  return (
    <FormPanel
      label={
        <FormattedMessage
          id="TAPIS__USERS__DETAIL__PANEL_TITLE"
          defaultMessage="Základní informace"
        />
      }
    >
      <FormTextField
        name="role.name"
        label={
          <FormattedMessage
            id="TAPIS__USERS__DETAIL__FIELD_LABEL__ROLE"
            defaultMessage="Role"
          />
        }
        disabled
      />
      <FormTextField
        name="lastName"
        label={
          <FormattedMessage
            id="TAPIS__USERS__DETAIL__FIELD_LABEL__LAST_NAME"
            defaultMessage="Příjmení"
          />
        }
        disabled
      />
      <FormTextField
        name="firstName"
        label={
          <FormattedMessage
            id="TAPIS__USERS__DETAIL__FIELD_LABEL__FIRST_NAME"
            defaultMessage="Křestní jméno"
          />
        }
        disabled
      />
      <FormTextField
        name="username"
        label={
          <FormattedMessage
            id="TAPIS__USERS__DETAIL__FIELD_LABEL__LAST_NAME"
            defaultMessage="Uživatelské jméno"
          />
        }
      />
      <FormTextField
        name="email"
        label={
          <FormattedMessage
            id="TAPIS__USERS__DETAIL__FIELD_LABEL__EMAIL"
            defaultMessage="Email"
          />
        }
      />
    </FormPanel>
  );
}
